
import {action, observable} from "mobx";
import {Transport} from "data/transport";
import {IHRDashboardData} from "data/hr/IHRDashboardData";


export class HRDashboardData {
  @observable data:IHRDashboardData;
  @observable initialized = false;

  @action init = () => {
    Transport.GET('/hr/dashboard')
      .then(action((response:IHRDashboardData)=>{
        this.data = response;
        this.initialized = true;
      }))
      .catch((e)=>{
        console.log(e);
      });
  }

  constructor() {
    this.init();
  }
}
